var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function LogoIconsEtsyIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 18H10V13H14V13.9957C14 14.549 14.4477 15 15 15C15.5561 15 16 14.5504 16 13.9957V10.0043C16 9.45098 15.5523 9 15 9C14.4439 9 14 9.44963 14 10.0043V11H10V6H17V7.00104C17 7.55087 17.4477 8 18 8C18.5561 8 19 7.55275 19 7.00104V5C19 4.44386 18.5542 4 18.0044 4H5.99562C5.44995 4 5 4.44772 5 5C5 5.55614 5.44576 6 5.99562 6H8V18H5.99562C5.44995 18 5 18.4477 5 19C5 19.5561 5.44576 20 5.99562 20H18.0044C18.5501 20 19 19.5523 19 19V16.999C19 16.4472 18.5561 16 18 16C17.4477 16 17 16.4491 17 16.999V18Z", fill: "" })));
}
export var LogoIconsEtsyIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: LogoIconsEtsyIconInner }, props))); };
//# sourceMappingURL=LogoIconsEtsyIcon.js.map